/**
 * Created by jonas on 2023-01-12.
 */
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {BS2} from "../BS2";
import {gsap} from "gsap";
import {ReelUtils} from "../utils/ReelUtils";

export class BS2AvalancheResult {

    constructor() {
    }

    start(flowStateController: FlowStateController): void {

        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                flowStateController.finish();
            }
        });
        tl.add(BS2.reelView.reels[0].model.fillUp(BS2.model.clientReels.matrix[0], ReelUtils.symbolStopFillUp));
        tl.add(BS2.reelView.reels[1].model.fillUp(BS2.model.clientReels.matrix[1], ReelUtils.symbolStopFillUp));
        tl.add(BS2.reelView.reels[2].model.fillUp(BS2.model.clientReels.matrix[2], ReelUtils.symbolStopFillUp));
        tl.add(BS2.reelView.reels[3].model.fillUp(BS2.model.clientReels.matrix[3], ReelUtils.symbolStopFillUp));
        tl.add(BS2.reelView.reels[4].model.fillUp(BS2.model.clientReels.matrix[4], ReelUtils.symbolStopFillUp));
        tl.to(this, {duration: 0.01});


        /*
                SlotGame.apiPlugin.betHandler.zeroBet();
                flowStateController.finish();*/
    }
}